type LabelSource = Record<string, string | undefined>;

const normalizeTypeOfOutcome = (value: unknown): string =>
	String(value ?? '')
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_');

export const resolveAssessmentTypeOfOutcomeLabel = (
	typeOfOutcome: unknown,
	labels: LabelSource
): string => {
	switch (normalizeTypeOfOutcome(typeOfOutcome)) {
		case 'feedback':
			return labels.feedbackBtn || labels.survey || 'Feedback';
		case 'assessment':
			return labels.assessment || 'Assessment';
		case 'learning':
			return labels.assessmentBtn || labels.assessment || 'Assessment';
		default:
			return '';
	}
};

export const resolveAssessmentButtonLabel = ({
	typeOfOutcome,
	configuredLabel,
	labels
}: {
	typeOfOutcome: unknown;
	configuredLabel?: string | null;
	labels: LabelSource;
}): string =>
	String(
		resolveAssessmentTypeOfOutcomeLabel(typeOfOutcome, labels) ||
		configuredLabel ||
		labels.assessmentBtn ||
		labels.assessment ||
		'Assessment'
	);
